const tiers = {};

const tierNames = ["tier1", "tier2", "tier3", "tier4"];

tierNames.forEach((t) => {
  tiers[t] = t;
});

module.exports = { ...tiers };
